<template>
  <jt-card-default
    :shouldShowSelectMonth="false"
    :cardSelectType="0"
    @change="onChangeSelectBar"
  >
    <div v-if="isLoadingBar" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-bar-chart
      v-else
      centralTitleConst="DASHBOARD_BILLING_RS"
      class="editCss"
      :data="collectionsData"
      :xAxisData="collectionsColumn"
      :shouldShowOverlappingBars="false"
      :yAxisIndexNames="['R$']"
    />
  </jt-card-default>
</template>

<script>
import JtBarChart from 'src/components/charts/JtBarChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import moment from 'moment'

@Component({
  name: 'Invoicing',
  components: {
    JtCardDefault,
    JtBarChart
  }
})
export default class Invoicing extends Vue {
  isLoadingBar = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  };

  registers = [];
  collectionsColumn = [];
  collectionsData = [];

  async onChangeSelectBar (date) {
    this.isLoadingBar = true

    const monthValuesProjected = await this.getProjectedMonths(date)

    this.registers = await this.getDoughnutData(date)

    const monthValues = Array.from({ length: 12 }, (item, index) => 0)

    if (this.registers.length != 0) {
      this.registers.forEach(register => {
        monthValues[register.month - 1] = Number(register.value.replaceAll('.', '').replace(',', '.'))
      })
    }

    moment.locale('pt')
    this.collectionsColumn = moment.monthsShort()

    this.collectionsData = [
      {
        data: monthValues,
        name: this.$gettext('DASHBOARD_BILLING_REALIZED'),
        type: 'bar',
        yAxisIndex: 0
      },
      {
        data: monthValuesProjected,
        name: this.$gettext('DASHBOARD_BILLING_BUDGETED'),
        type: 'bar',
        yAxisIndex: 0
      }
    ]

    setTimeout(() => {
      this.isLoadingBar = false
    }, 500)
  }

  async created () {
    await this.onChangeSelectBar(this.currentDate)
  }

  async getDoughnutData (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'invoicing',
        year: date.year
      }
    )
    return registros
  }

  async getProjectedMonths (date) {
    const monthValuesProjected = Array.from({ length: 12 }, (item, index) => '0')

    const { registros } = await repository.resolveDatatableModel(
      'projectedMonth.pesquisar',
      {
        grid: 'pesquisa',
        projectedMonthType: 20450002,
        year: date.year
      }
    )
    if (registros.length != 0) {
      const projectedMonth = registros[0]
      monthValuesProjected[0] = (projectedMonth.jan ? projectedMonth.jan : '0')
      monthValuesProjected[1] = (projectedMonth.feb ? projectedMonth.feb : '0')
      monthValuesProjected[2] = (projectedMonth.mar ? projectedMonth.mar : '0')
      monthValuesProjected[3] = (projectedMonth.apr ? projectedMonth.apr : '0')
      monthValuesProjected[4] = (projectedMonth.may ? projectedMonth.may : '0')
      monthValuesProjected[5] = (projectedMonth.jun ? projectedMonth.jun : '0')
      monthValuesProjected[6] = (projectedMonth.jul ? projectedMonth.jul : '0')
      monthValuesProjected[7] = (projectedMonth.aug ? projectedMonth.aug : '0')
      monthValuesProjected[8] = (projectedMonth.sep ? projectedMonth.sep : '0')
      monthValuesProjected[9] = (projectedMonth.oct ? projectedMonth.oct : '0')
      monthValuesProjected[10] = (projectedMonth.nov ? projectedMonth.nov : '0')
      monthValuesProjected[11] = (projectedMonth.dec ? projectedMonth.dec : '0')

      monthValuesProjected.forEach((register, index) => {
        monthValuesProjected[index] = parseFloat(register.replaceAll('.', '').replaceAll(',', '.'))
      })
    }
    return monthValuesProjected
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';
</style>
